/**
 * Inline sekcijska navigacija u home header-u (scroll-spy linkovi ka anchor sekcijama).
 */

import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useHomeSectionNav } from '../context/HomeSectionNavContext';
import { useHomeSectionNavPlacement } from '../hooks/useHomeSectionNavPlacement';

const HomeSectionNav = () => {
  const { pathname } = useLocation();
  const nav = useHomeSectionNav();
  const navRef = useRef(null);
  const listRef = useRef(null);

  const isHome = pathname === '/';
  const hasSections = (nav?.sections?.length ?? 0) > 0;
  const sectionsKey = nav?.sections?.map((s) => s.id).join(',') ?? '';

  useHomeSectionNavPlacement({
    enabled: isHome && hasSections,
    navRef,
    listRef,
    sectionsKey,
    setPlacement: nav?.setPlacement,
  });

  if (!isHome || !hasSections) {
    return null;
  }

  const isCompact = nav.placement === 'burger';

  return (
    <nav
      ref={navRef}
      className={`home-section-nav${isCompact ? ' home-section-nav--compact' : ''}`}
      aria-label="Секције почетне странице"
      aria-hidden={isCompact || undefined}
    >
      <ul ref={listRef} className="home-section-nav-list">
        {nav.sections.map(({ id, label }) => {
          const isActive = nav.activeSectionId === id;
          return (
            <li key={id}>
              <button
                type="button"
                className={`home-section-nav-link${isActive ? ' home-section-nav-link--active' : ''}`}
                aria-current={isActive ? 'true' : undefined}
                tabIndex={isCompact ? -1 : undefined}
                onClick={() => nav.scrollToSection(id)}
              >
                {label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default HomeSectionNav;
